export enum DocumentBaseVariableId {
  DOCUMENT_CREATION_DATE = 'documentCreationDate',
  DOCUMENT_CREATION_DATE_NO_HASH = 'documentCreationDateNoHash',
  DOCUMENT_REPLACE_NOTE = 'documentReplaceNote',
  DOCUMENT_NAME = 'documentName',
  DOCUMENT_START_GREETING = 'documentStartGreeting',
  DOCUMENT_END_GREETING = 'documentEndGreeting',
}
